import { type ComponentProps, memo, useCallback } from "react";

import {
  useCartLine,
  type CartLineQuantityAdjustButton,
} from "@shopify/hydrogen-react";

import { CartItemQuantitySelectorView } from "@cart/CartItemQuantitySelector/CartItemQuantitySelector.view";
import { useCartAnalytics } from "@react/hooks/useCartAnalytics";

const CartItemQuantitySelectorBase = () => {
  const line = useCartLine();
  const { reportQuantitySelectorEvent } = useCartAnalytics();

  const onQuantityChange = useCallback(
    ({
      adjust,
      quantity,
    }: {
      adjust: ComponentProps<typeof CartLineQuantityAdjustButton>["adjust"];
      quantity: number;
    }) => {
      reportQuantitySelectorEvent({
        adjust,
        line,
        quantity,
      });
    },
    [line, reportQuantitySelectorEvent]
  );

  return <CartItemQuantitySelectorView onQuantityChange={onQuantityChange} />;
};

export const CartItemQuantitySelector = memo(CartItemQuantitySelectorBase);
